import { AxiosError } from "axios";
import TApiErrorMessage from "../../../types/api/TApiErrorMessage";

// axios 0.27 以降は AxiosError のレスポンス本文の型が unknown になったため、ここで本文の型を定める
type TApiErrorResponse = TApiErrorMessage & { message: string; detail: string };

const getErrorProperty = (
  e: AxiosError,
  api: string
): { status: number; message: string; errorMessages?: TApiErrorMessage } => {
  let status = e.response?.status;
  let message = "";
  const data = e.response?.data as TApiErrorResponse;

  if (e.response && status === 400) {
    const errorMessage: TApiErrorMessage = data;
    return {
      status: status,
      message: data.message,
      errorMessages: errorMessage,
    };
  }
  if (e.response && status === 404) {
    message = data.message;
  }
  if (e.response && status === 401) {
    message = "タイムアウトしました。";
  }
  if (e.response && status === 409) {
    message = data.detail;
  }
  if (e.response && status === 500) {
    message = data.message;
  }
  status = status || 500;

  return { status, message };
};
export default getErrorProperty;
